import { Controller } from "@hotwired/stimulus";

// Native confirm() guard for submits/links that don't go through Turbo
// (Turbo's data-turbo-confirm only fires when Turbo handles the request).
// Usage: data-controller="confirm" data-action="click->confirm#check"
//        data-confirm-message-value="Are you sure?"
export default class extends Controller {
  static values = { message: String };

  check(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault();
    }
  }
}
